// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewSimulation_root__1DxG9","content":"ViewSimulation_content__1FLW-","control":"ViewSimulation_control__3N9db","tourFistStep":"ViewSimulation_tourFistStep__K1EwY"};